import { get, post } from './http-calls';

export const getAllVehicleCategories = async () => {
    let res = await get(`VehicleCategories`, { useAuthToken: true });
    return res;
};

export const getVehicleCategoriesById = async (id) => {
    let res = await get(`VehicleCategories/${id}`, { useAuthToken: true });
    return res;
};

export const postVehicleCategoriesData = async (data) => {
    let res = await post(`VehicleCategories`, data, { useAuthToken: true });
    return res;
};
